import { httpGet } from "../services/apiService";
import Fuse from "fuse.js"

export const metalicosModule = {
    state: () => ({
        fetchingMetalicos: false,
        errorFetchingMetalicos: false,
        allMetalicos: [],
        selectedMetalicos: [],
        fuseMetalicos: [],
        totalMetalicos: 0,
        totalPesoMetalicos: 0,
    }),
    mutations: {
        setFetchingMetalicos(state, newValue) {
            state.fetchingMetalicos = newValue;
        },
        setErrorFetchingMetalicos(state, newValue) {
            state.errorFetchingMetalicos = newValue;
        },
        setAllMetalicos(state, newValue) {
            state.allMetalicos = newValue;
        },
        setSelectedMetalicos(state, newValue) {
            state.selectedMetalicos = newValue;
        },
        setFuseMetalicos(state, newValue) {
            state.fuseMetalicos = newValue;
        },
        setTotalMetalicos(state, newValue) {
            state.totalMetalicos = newValue;
        },
        setTotalPesoMetalicos(state, newValue) {
            state.totalPesoMetalicos = newValue;
        },
    },
    actions: {
        async getMetalicos({ state, commit }) {
            const { data } = await httpGet("/productos?filters[familia][$eq]=metalicos");
            ("Metalicos:", data?.data);
            commit("setAllMetalicos", data?.data);
            commit("setFuseMetalicos", new Fuse([...state.allMetalicos], {
                keys: ["attributes.codigo", "attributes.descripcion"],
            }));
        },
        addMetalico({ state, rootState, commit }, newValue) {
            const valorFlete = rootState?.destinies?.selectedDestiny?.attributes?.valor_flete;

            // Flatten product object
            let newEntry = {
                ...newValue.attributes,
                id: newValue.id,
                cantidad: 1,
                largo: 1,
            };

            // Set unit options.
            let unitOptions = [];
            for (const f in newEntry.factores) {
                if (Object.hasOwnProperty.call(newEntry.factores, f)) {
                    const element = newEntry.factores[f];
                    unitOptions.push({ text: element.referencia, value: element });
                }
            }

            newEntry.unit_options = unitOptions.filter(u => u.value.activo == true);
            newEntry.selected_unit = newEntry.unit_options[0].value ?? null;

            // Set discounts
            newEntry.minDiscount = 0;
            newEntry.maxDiscount = 100;
            if (rootState.client?.selectedClient == null) {
                newEntry.descuento_seleccionado = 0;
            }
            else {
                newEntry.descuento_seleccionado = rootState?.client?.selectedClient?.attributes?.descuento_metalicos ?? 0;
            }

            // Set calculated price fields.
            newEntry.precio_provicional_uno = newEntry.precio_lista / newEntry.factores.metro_cuadrado.valor;
            newEntry.precio_provicional_dos = newEntry.precio_provicional_uno * (1 - newEntry.descuento_seleccionado / 100)
            newEntry.flete_provicional = (valorFlete * newEntry.factores.kilogramo.valor) / newEntry.factores.metro_cuadrado.valor;
            newEntry.precio_unitario_final = (newEntry.precio_provicional_dos + newEntry.flete_provicional) * newEntry.largo;
            newEntry.total_local = newEntry.precio_unitario_final * newEntry.cantidad;

            // Set calculated weight fields.
            newEntry.peso_calculado = newEntry.cantidad * (newEntry.selected_unit.peso_por_unidad ?? 0) * newEntry.largo;

            if (newEntry.selected_unit.peso_por_unidad == null) {
                commit("setWarningsPeso", [...rootState.warningsPeso, newEntry]);
            }

            ("new metalico:", newEntry);
            commit("setSelectedMetalicos", [...state.selectedMetalicos, newEntry]);
        },
        updateMetalicos({ state, rootState, commit }, item) {
            const valorFlete = rootState?.destinies?.selectedDestiny?.attributes?.valor_flete;

            if (item.descuento_seleccionado >= item.maxDiscount) {
                item.descuento_seleccionado = item.maxDiscount;
            }
            if (item.descuento_seleccionado <= item.minDiscount) {
                item.descuento_seleccionado = 0;
            }

            // Set calculated price fields.
            item.precio_provicional_uno = item.precio_lista / item.factores.metro_cuadrado.valor;
            item.precio_provicional_dos = item.precio_provicional_uno * (1 - item.descuento_seleccionado / 100)
            item.flete_provicional = (valorFlete * item.factores.kilogramo.valor) / item.factores.metro_cuadrado.valor;
            item.precio_unitario_final = (item.precio_provicional_dos + item.flete_provicional) * item.largo;
            item.total_local = item.precio_unitario_final * item.cantidad;

            // Set calculated weight fields.
            item.peso_calculado = item.cantidad * (item.selected_unit.peso_por_unidad ?? 0) * item.largo;

            commit('setSelectedMetalicos', [...state.selectedMetalicos]);
        },
        deleteMetalico({ state, rootState, commit, dispatch }, product) {
            commit("setSelectedMetalicos", state.selectedMetalicos.filter(p => p.id != product.id));
            commit("setWarningsPeso", rootState.warningsPeso.filter(p => p.id != product.id));
        },
        updateAllByDestiny({ state, dispatch }) {
            for (const item of state.selectedMetalicos) {
                dispatch("updateMetalicos", item);
            }

            dispatch("updateQuotationTotals");
        }
    }
}